import React, { useEffect, useState } from "react";
import { LOGO_URL, COMPANY, NAV_LINKS } from "@/lib/site-data";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            data-testid="header-logo-link"
            className="flex items-center gap-3 group"
          >
            <img
              src={LOGO_URL}
              alt="Creative Property Development"
              className="h-11 w-11 object-contain"
            />
            <div className="hidden md:flex flex-col leading-tight">
              <span className="font-display text-[15px] tracking-wide text-[var(--text-primary)]">
                Creative Property
              </span>
              <span className="font-body text-[10px] uppercase tracking-[0.3em] text-[var(--accent)]">
                Development
              </span>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-10">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="nav-link font-body"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#contact"
              className="btn-outline hidden md:inline-flex"
              data-testid="header-start-project-btn"
            >
              Start Project
            </a>
            <button
              data-testid="header-menu-toggle"
              aria-label="Toggle menu"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden h-10 w-10 flex items-center justify-center border border-white/15"
            >
              <span className="sr-only">Menu</span>
              <div className="flex flex-col gap-[5px]">
                <span
                  className={`h-[1px] w-5 bg-[var(--text-primary)] transition-transform ${
                    open ? "translate-y-[3px] rotate-45" : ""
                  }`}
                />
                <span
                  className={`h-[1px] w-5 bg-[var(--text-primary)] transition-transform ${
                    open ? "-translate-y-[3px] -rotate-45" : ""
                  }`}
                />
              </div>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        <div
          className={`md:hidden overflow-hidden transition-[max-height] duration-500 ${
            open ? "max-h-96" : "max-h-0"
          }`}
          data-testid="mobile-menu"
        >
          <div className="flex flex-col gap-4 pb-6 pt-2">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="nav-link font-body py-2"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-outline w-fit"
              data-testid="mobile-start-project-btn"
            >
              Start Project
            </a>
          </div>
        </div>
      </div>
      <span className="sr-only">{COMPANY.name}</span>
    </header>
  );
}
